import React from 'react'
import _ from 'lodash'
import {
  Col,
} from 'antd'
import {
  Div, H3, H4, P, Loading,
} from 'konsys-ui'
import { useQuery } from '@apollo/react-hooks'
import { BANKS, SUPPLIER } from '../../../constants/graph/query'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/inventory-components'
import { Remark } from '../../../components/common'
import { PAYMENT_TYPE, STATUS_TYPE } from '../constants'
import { renderText } from '../../../utils/util-services'
import { bankTextSelector } from '../util-functions'

export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(SUPPLIER, { variables: { id: parseInt(props.match.params.id, 10) } })
  const { data: bankData, loading: bankLoading, error } = useQuery(BANKS)
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  if (bankLoading && _.isUndefined(bankData)) return <Loading center='true' />
  const { data } = infoData.supplierDetail
  return (
    <Div margin='0 0 24px 0'>
      <Div display='flex' alignItems='center' width='100%' justifyContent='space-between' margin='0 0 16px 0'>
        <H3 color={theme.color.primaryColor}>ข้อมูลผู้ผลิต</H3>
        <H4>ID: {data.id}</H4>
      </Div>
      <Wrapper >
        <Div display='flex' alignItems='center' width='100%' margin='0 0 16px 0'>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >ชื่อ</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.name}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >เบอร์สำนักงาน</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.officeTel}</P>
          </Col>
          {/* <TextBetween
        title={{
          margin: '8px 0',
          text: 'ประเภท',
        }}
        content={{
          margin: '8px 0',
          text: data.personType === PERSON_TYPE.ORDINARY_PERSON ? 'บุคคลธรรมดา' : 'นิติบุคคล',
          color: '#968595',
        }}
      /> */}
          {/* <TextBetween
        title={{
          margin: '8px 0',
          text: 'คำนำหน้า',
        }}
        content={{
          margin: '8px 0',
          text: renderText(data.prefix),
          color: '#968595',
        }}
      /> */}
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >ที่อยู่ (URL)</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>
              <a href={_.includes(data.addressUrl, 'https://') ? `https://${data.addressUrl.slice(8)}` : `https://${data.addressUrl}`} target="_blank" rel="noopener noreferrer">
              {data.addressUrl}
              </a>
              </P>
          </Col>
        </Div>
        <Div display='flex' alignItems='center' width='100%' margin='0 0 16px 0'>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >เลขประจำตัวผู้เสียภาษี</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(data.taxId)}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >รูปแบบการจ่ายเงิน</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.paymentType === PAYMENT_TYPE.CASH ? 'เงินสด' : 'เครดิต'}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >สถานะ</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.status === STATUS_TYPE.ACTIVE ? 'ใช้อยู่' : 'เลิกใช้'}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >VAT</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.isVat ? 'มี VAT' : 'ไม่มี VAT'}</P>
          </Col>
        </Div>
        {/* <TextBetween
        title={{
          margin: '8px 0',
          text: 'VAT',
        }}
        content={{
          margin: '8px 0',
          text: data.isVat ? 'เก็บ' : 'ไม่เก็บ',
          color: data.isVat ? theme.color.success : theme.color.error,
        }}
      /> */}
      </Wrapper>
      {
        data.paymentType === PAYMENT_TYPE.CREDIT
        && <Wrapper >
          <Div display='flex' alignItems='center' width='100%' margin='0 0 16px 0'>
          {/* <TextBetween
            title={{
              margin: '8px 0',
              text: 'วงเงิน',
            }}
            content={{
              margin: '8px 0',
              text: data.creditLimit,
              color: '#968595',
            }}
          />
          <TextBetween
            title={{
              margin: '8px 0',
              text: 'วงเงินที่ใช้ไปแล้ว',
            }}
            content={{
              margin: '8px 0',
              text: data.creditUsage,
              color: '#968595',
            }}
          />
          <TextBetween
            title={{
              margin: '8px 0',
              text: 'วงเงินที่เหลือ',
            }}
            content={{
              margin: '8px 0',
              text: data.creditLimit - data.creditUsage,
              color: '#968595',
            }}
          /> */}
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >ระยะเครดิต</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.creditTerm}</P>
          </Col>
          </Div>
        </Wrapper>
      }
      {/* <Div display='flex' flexDirection='column' padding='8px' margin='8px 0' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: theme.color.veryLightBlue }}> */}
      {/* <Div display='flex' flexDirection='column' padding='8px' margin='8px 0' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: theme.color.veryLightBlue }}> */}
      {/* </Div> */}
      {/* </Div> */}
      <Div display='flex' flexDirection='column' padding='8px' margin='8px 0' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: theme.color.veryLightBlue }}>
        <Wrapper >
          <Div width='100%' margin='0 0 16px 0'>
            <P bold margin='0 0 16px 0'>ผู้ติดต่อ</P>
          </Div>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >ชื่อ</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(data.contactName)}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >เบอร์</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(data.contactPhoneNumber)}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >แฟกซ์</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(data.contactFaxNumber)}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >อีเมล์</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(data.contactEmail)}</P>
          </Col>
          <Col span='6' offset={data.offset}>
            <P margin='0 8px 16px 0' width='100%' display='block' >Line</P>
            <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(data.contactLineId)}</P>
          </Col>
        </Wrapper>
        <Wrapper >
          <P bold margin='0 0 32px 0'>ข้อมูลธนาคาร</P>
          {data.paymentInfo.length > 0
            && data.paymentInfo.map((bank, index) => (
              <Div key={bank.id}>
                <Col span='1' offset={data.offset}>
                  <P>{index + 1}.</P>
                </Col>
                <Col span='6' offset={data.offset}>
                  <P margin='0 8px 16px 0' width='100%' display='block' >ธนาคาร</P>
                  <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(!_.isNull(bank.bankId) ? _.find(bankData.bankList.data.list, o => o.id === bank.bankId).name : '')}</P>
                </Col>
                <Col span='6' offset={data.offset}>
                  <P margin='0 8px 16px 0' width='100%' display='block' >เลขบัญชี</P>
                  <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(bank.bankAccountNumber)}</P>
                </Col>
                <Col span='6' offset={data.offset}>
                  <P margin='0 8px 16px 0' width='100%' display='block' >ชื่อบัญชี</P>
                  <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{renderText(bank.bankAccountName)}</P>
                </Col>
                <Col span='5' offset={data.offset}>
                  <P margin='0 8px 16px 0' width='100%' display='block' >ประเภทบัญชี</P>
                  <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{bankTextSelector(bank.bankAccountType)}</P>
                </Col>
              </Div>
            ))
          }
        </Wrapper>
      </Div>
      <Remark showIcon message='หมายเหตุ' description={data.contactRemark || '-'} />
    </Div>
  )
}
